const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{6,}$/;
const YOUTUBE_TEXT_URL_PATTERN = /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/[^\s]+/i;

const trimTrailingPunctuation = (value = '') =>
    String(value).replace(/[),.!?;:'"]+$/g, '').trim();

const normalizeUrl = (rawUrl = '') => {
    const cleaned = trimTrailingPunctuation(rawUrl);
    if (!cleaned) return '';
    if (/^[a-z][a-z0-9+\-.]*:\/\//i.test(cleaned)) return cleaned;
    return `https://${cleaned}`;
};

const parseUrl = (rawUrl = '') => {
    const normalized = normalizeUrl(rawUrl);
    if (!normalized) return null;
    try {
        return new URL(normalized);
    } catch {
        return null;
    }
};

const coerceVideoId = (rawId = '') => {
    const cleaned = String(rawId).trim();
    return YOUTUBE_ID_PATTERN.test(cleaned) ? cleaned : '';
};

const extractPathVideoId = (pathname = '') => {
    const segments = String(pathname).split('/').filter(Boolean);
    if (!segments.length) return '';

    if (segments[0] === 'shorts' || segments[0] === 'embed' || segments[0] === 'live' || segments[0] === 'v') {
        return coerceVideoId(segments[1] || '');
    }

    return coerceVideoId(segments[0] || '');
};

export const getYouTubeVideoId = (rawUrl = '') => {
    const parsed = parseUrl(rawUrl);
    if (!parsed) return '';

    const host = parsed.hostname.toLowerCase();
    const isYoutubeHost =
        host === 'youtube.com' ||
        host.endsWith('.youtube.com') ||
        host === 'youtu.be';

    if (!isYoutubeHost) return '';

    if (host === 'youtu.be') {
        return extractPathVideoId(parsed.pathname);
    }

    if (parsed.pathname === '/watch') {
        return coerceVideoId(parsed.searchParams.get('v') || '');
    }

    return extractPathVideoId(parsed.pathname);
};

export const getYouTubeEmbedUrl = (rawUrl = '') => {
    const id = getYouTubeVideoId(rawUrl);
    return id ? `https://www.youtube.com/embed/${id}` : '';
};

export const extractFirstYouTubeUrlFromText = (text = '') => {
    const match = String(text || '').match(YOUTUBE_TEXT_URL_PATTERN);
    if (!match?.[0]) return '';
    return normalizeUrl(match[0]);
};
